import templateUrl from './publications-documents-call-center-statistics.html';

export const publicationsDocumentsCallCenterStatisticsComponent = {
	templateUrl,

	bindings: {
		details: '<'
	},

	controller: class PublicationsDocumentsCallCenterStatisticsComponent {
		constructor(CallCenterStatisticsService) {
			'ngInject';

			this.callCenterStatisticsService = CallCenterStatisticsService;
		}
		
		$onInit() {
			this.details = this.callCenterStatisticsService.getReportDetails(this.details);
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/publications-documents-call-center-statistics/publications-documents-call-center-statistics.component.js